<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     用户头像
  +---------------------------------------------------------------------------------------
-->
<template>
  <el-image
    class="f-user-avatar image"
    :class="{ [size]: size, [shape]: shape }"
    :src="src"
    :preview-src-list="preview ? [src] : []"
  >
    <div slot="error">
      <img
        class="image"
        :class="{ [size]: size, [shape]: shape }"
        src="@/assets/default-avatar.png"
      />
    </div>
  </el-image>
</template>

<script>
export default {
  name: "FUserAvatar",

  props: {
    src: {
      type: String,
      default: "",
    },

    size: {
      type: String,
      default: '',
    },

    shape: {
      type: String,
      default: 'circle'
    },

    preview: {
      type: Boolean,
      default: true,
    }
  },

  data() {
    return {};
  },

  methods: {
  },
}
</script>
